import React from 'react'
import Helmet from 'react-helmet'
import get from 'lodash/get'
import { documentToReactComponents } from "@contentful/rich-text-react-renderer"
import { contentfulMapToLocalized } from "../../helpers.js"
import defaultRTRenderOptions from "../../../contentful/rich-text-renderer-options"

class ColumnsBlock extends React.Component {
  render() {
    let {sys: { id }, fields:  { title, columns, extraAttributes }} = this.props.node
    title = get(title, 'en-US')
    columns = get(columns, 'en-US')
    extraAttributes = get(extraAttributes, 'en-US')
    
    const containerClass = `col-md-${12 / columns.length}`
    columns = columns.map((column) => {
      let newColumns = column.fields
      newColumns = contentfulMapToLocalized(newColumns)
      
      return newColumns
    })
    
    const options = {
      ...defaultRTRenderOptions
    }
    return (
      <>
        <div className="block-colums row">
          {columns.map((column) => {
            const header = column.header ? (<h4>{column.header}</h4>) : "";
            return (
              <div className={containerClass}>
                { header }
                { documentToReactComponents(column.content, options) }
              </div>
            )
          })}
        </div>
      </>
    )
  }
}

export default ColumnsBlock
